<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="assessment"></progress-components>
      <v-form ref="form" class="mt-12">
        <interview-link></interview-link>
        <v-card
          class="mx-auto mt-1"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>診断 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="diagnostic"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectDiagnosticResult" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            <v-radio value="その他" color="doorMainColor">
              <template v-slot:label>
                <v-responsive class="ml-1" max-width="344">
                  <v-text-field
                    label="その他"
                    v-model="diagnosticOther"
                    variant="underlined"
                    :rules="[requiredOtherText([diagnostic,diagnosticOther])]"
                  ></v-text-field>
                </v-responsive>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>所見</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
            <div class="mx-5 mb-6">可能な限り詳細にご記入いただけますと幸いです。</div>
            <v-responsive
              class="mx-5"
              max-width="600"
            >
              <v-textarea
                label="回答を入力"
                variant="underlined"
                :rules="[required]"
                v-model="finding"
                rows="5"
              ></v-textarea>
            </v-responsive>
        </v-card>
      </v-form>
    </v-container>
    <v-container>
      <v-row v-if="fromConfirm" justify="center" align-content="center" class="mb-6">
        <v-btn
          dark
          color="doorAccentColor"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="clickedNextPage"
        >確認
        </v-btn>
      </v-row>
      <v-row v-else justify="center" align-content="center" class="mb-6">
        <v-btn
          dark
          color="#B0B6BA"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="toBack"
        >戻る
        </v-btn>
        <v-btn
          dark
          x-large min-width="362px"
          color="doorAccentColor"
          class="mb-4 mx-4 white--text"
          @click="clickedNextPage"
        >次へ
        </v-btn>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, computed, ref } from 'vue'
import { Logger } from 'aws-amplify'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/MedicalRecordTitle.vue'
import ProgressComponents from '@/components/MedicalRecordProgress.vue'
import { useScreenOperation } from '@/func/useScreenOperation'
import { useMedicalValues } from '@/const/form/useMedicalValues'
import { useFormValidator } from '@/func/useFormValidator'
import InterviewLink from '@/components/InterviewLink.vue'

const logger = new Logger('AdvanceForm');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents,
    'interview-link': InterviewLink
  },
  setup() {
    const { scrollToTop, fromConfirmScreen, scrollToErrorPosition } = useScreenOperation()
    const fromConfirm = computed(() => fromConfirmScreen())
    const form = ref(null)

    logger.info('MedicalRecord Assessment')
    scrollToTop()
    const { selectDiagnosticResult } = useMedicalValues()
    const { required, requiredOtherText } = useFormValidator()

    const store = useStore()
    const diagnostic = computed({
      get: () => store.state.medicalRecord.diagnostic,
      set: (value) => store.dispatch('medicalRecord/setDiagnostic', value)
    })
    const diagnosticOther = computed({
      get: () => store.state.medicalRecord.diagnosticOther,
      set: (value) => store.dispatch('medicalRecord/setDiagnosticOther', value)
    })
    const finding = computed({
      get: () => store.state.medicalRecord.finding,
      set: (value) => store.dispatch('medicalRecord/setFinding', value)
    })


    const router = useRouter()
    const toBack = () => router.go(-1)

    const clickedNextPage = async () => {
      const result = await form.value.validate()
      if (!result.valid) {
        scrollToErrorPosition()
        return
      }
      if (fromConfirm.value) {
        router.push('/record/confirm')
      } else {
        router.push('/record/plan')
      }
    }
    return {
      fromConfirm,
      clickedNextPage,
      toBack,
      selectDiagnosticResult,
      required,
      requiredOtherText,
      diagnostic,
      diagnosticOther,
      finding,
      form
    }
  }
})
</script>
